import { type Me, ROLE_LABELS } from "@pcj/shared";
import { ArrowLeft, LogOut, UserRound } from "lucide-react";
import { Link } from "react-router";
import { useSignOut } from "../lib/auth-client";

export function AppHeader({ me, title, backTo }: { me: Me; title: string; backTo?: string }) {
  const signOut = useSignOut();

  return (
    <header className="bg-charcoal px-4 py-4 sm:px-8">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-3">
          {backTo && (
            <Link to={backTo} className="rounded p-1 text-gray-300 hover:text-white" aria-label="Volver">
              <ArrowLeft className="h-4 w-4" />
            </Link>
          )}
          <div className="min-w-0">
            <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-gold-500">
              Sistema automatizado de cumplimiento PLD/FT
            </p>
            <h1 className="truncate text-base font-semibold text-white sm:text-lg">{title}</h1>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-4">
          <Link
            to="/account"
            className="group rounded text-right"
            title="Mi cuenta"
            aria-label={`Mi cuenta: ${me.profile.name ?? me.user.name}`}
          >
            <p className="hidden text-xs text-white group-hover:underline sm:block">
              {me.profile.name ?? me.user.name}
            </p>
            <p className="hidden text-[11px] text-gray-400 sm:block">{ROLE_LABELS[me.profile.role]}</p>
            <UserRound className="h-4 w-4 text-gray-300 sm:hidden" aria-hidden />
          </Link>
          <button
            type="button"
            onClick={signOut}
            className="flex items-center gap-1.5 rounded px-2 py-1 text-xs text-gray-300 hover:text-white"
          >
            <LogOut className="h-3.5 w-3.5" aria-hidden /> Salir
          </button>
        </div>
      </div>
    </header>
  );
}
